import { PRESSURE_UNITS_VALUES } from "../pages/admin-details/account/constants";

export const convertFromKpa = (
  valueInKpa: number,
  to: PRESSURE_UNITS_VALUES
): number => {
  switch (to) {
    case PRESSURE_UNITS_VALUES.KPA:
      return valueInKpa;
    case PRESSURE_UNITS_VALUES.PSI:
      return valueInKpa / 6.89476;
    case PRESSURE_UNITS_VALUES.MMHG:
      return valueInKpa / 0.133322;
    case PRESSURE_UNITS_VALUES.BAR:
      return valueInKpa / 100;
    default:
      return valueInKpa;
  }
};
export const convertToKpaForApi = (
  value: number,
  from: PRESSURE_UNITS_VALUES
): number => {
  switch (from) {
    case PRESSURE_UNITS_VALUES.KPA:
      return value;
    case PRESSURE_UNITS_VALUES.PSI:
      return value * 6.89476;
    case PRESSURE_UNITS_VALUES.MMHG:
      return value * 0.133322;
    case PRESSURE_UNITS_VALUES.BAR:
      return value * 100;
    default:
      return value;
  }
};

